import { type ComboboxOption } from "../InfoHub/Components/Form/Components/MultiSelectCombobox";
import { type AdministrativeAreaNode, type EntityId, type ExchangeLocation } from "./types";

export const EMPTY_VALUE = "-";

export const flattenAdministrativeAreas = (
  nodes?: AdministrativeAreaNode[] | null,
  depth = 0
): ComboboxOption[] =>
  (nodes ?? []).flatMap(node =>
    node.value === undefined || node.value === null
      ? flattenAdministrativeAreas(node.children, depth)
      : [
          { depth, label: node.label ?? "", value: node.value },
          ...flattenAdministrativeAreas(node.children, depth + 1),
        ]
  );

export const getAreaLabel = (id: EntityId | null | undefined, options: ComboboxOption[]) => {
  if (id === undefined || id === null) {
    return "";
  }

  return options.find(option => String(option.value) === String(id))?.label ?? "";
};

export const getAssignments = (location: ExchangeLocation) =>
  (location.assignments ?? []).filter(assignment => (assignment.types ?? []).length > 0);

export const countLinkedTraders = (location: ExchangeLocation) => getAssignments(location).length;

export const countTradersForType = (location: ExchangeLocation, typeId: EntityId) =>
  getAssignments(location).filter(assignment =>
    (assignment.types ?? []).some(type => String(type) === String(typeId))
  ).length;
